import * as React from "react";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { Box } from "@mui/system";
import { InputAdornment, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

// import SearchIcon from "@material-ui/icons/Search";
export default function CustomSerachBar({
  onSearchClick,
  tiltle,
  placeholder,
}) {
  const [serachText, setSearchText] = React.useState("");

  const didMount = React.useRef(false);
  const { t } = useTranslation();

  const handler = React.useCallback(() => {
    // Clear the previous timeout if it exists
    clearTimeout(timeoutId.current);

    // Set a new timeout to call onSearchClick after 1000ms
    timeoutId.current = setTimeout(() => {
      onSearchClick(serachText);
    }, 1000);
  }, [serachText]);

  React.useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }

    handler();
  }, [serachText, handler]);

  const timeoutId = React.useRef(null);

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="h4" color={"primary.main"} sx={{ mb: 1 }}>
        {tiltle}
      </Typography>
      <TextField
        sx={{
          backgroundColor: "#DADADA63",
          borderColor: "#DADADA63",
          "& fieldset": { border: "none" },
          borderRadius: "10px",
        }}
        fullWidth
        size="small"
        placeholder={
          placeholder ? placeholder : t("pages.reservation.searchPlaceholder")
        }
        value={serachText}
        onChange={(event) => {
          setSearchText(event?.target?.value);
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment>
              <IconButton
                onClick={() => {
                  onSearchClick(serachText);
                }}
              >
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}
